import { useEffect, useState } from 'react'
import { getMapData, Space as MappedinSpaceRaw } from '@mappedin/mappedin-js'
import { getRequest } from 'models/api/rest'
import { API_BEACONS } from 'lib/constants'
import { RoomMap, SpaceMap } from 'lib/utils/mappedin'


export type MIOptions = {
  mapId: string
  key: string
  secret: string
}

export type BeaconRoom = {
  id: string
  name: string
  room: string
}


// 🧭 Mappedin: useMappedInSpaces
export function useMappedInSpaces(options: MIOptions | null | undefined) {
  const [spaceMap, setSpaceMap] = useState<SpaceMap>({})

  useEffect(() => {
    if (!options) return

    const fetchSpaces = async () => {
      try {
        const mapData = await getMapData(options)
        const rawSpaces = mapData.getByType('space') as MappedinSpaceRaw[]

        const groupedByFloorName: SpaceMap = {}

        rawSpaces.forEach(space => {
          const floorName = space.floor.name?.trim()?.toLowerCase()
          if (!floorName) return

          if (!groupedByFloorName[floorName]) {
            groupedByFloorName[floorName] = []
          }

          groupedByFloorName[floorName].push({
            id: space.id,
            name: space.name,
            floorId: space.floor.id,
            polygon: space.geoJSON.geometry
          })
        })

        setSpaceMap(groupedByFloorName)
      } catch (err) {
        console.error('Failed to load Mappedin spaces:', err)
      }
    }
    if (!options) return
    fetchSpaces()
  }, [options])
  console.log('~~spaceMap', spaceMap)
  return spaceMap
}



// 🏢 React Mobile: useReactMobileRooms
export function useReactMobileRooms(orgId: string) {
  const [roomMap, setRoomMap] = useState<RoomMap>({})

  useEffect(() => {
    const fetchBeacons = async () => {
      try {
        const res = await getRequest({
          endpoint: `${API_BEACONS}`,
          header: { org_id: orgId },
        })

        const beacons = res.data.data
        const grouped: Record<string, BeaconRoom[]> = {}


        beacons.forEach((b: any) => {
          const floor = b.attributes?.floor?.trim()?.toLowerCase()
          const room = b.attributes?.room?.trim()
          const name = b.attributes?.name?.trim()
          const id = b.id

          if (floor && room) {
            if (!grouped[floor]) grouped[floor] = []

            const exists = grouped[floor].some(entry => entry.room === room && entry.id === id)
            if (!exists) {
              grouped[floor].push({
                id,
                name: name || room,
                room,
              })
            }
          }
        })

        setRoomMap(grouped)
      } catch (err) {
        console.error('Failed to load React Mobile rooms from beacons:', err)
      }
    }

    if (orgId) fetchBeacons()
  }, [orgId])
  console.log('~~roomMap', roomMap)
  return roomMap
}
